import { createIdentitiesFetcher } from '../contexts/Fetcher';
import { useParams } from 'react-router-dom';
import { apiUser } from '../resources/api/apiUser';

const { useGetUserInfo } = apiUser;

export const UserFullInfoFetcher = createIdentitiesFetcher(() => {
  const { user_id } = useParams<{ user_id: string }>();
  return useGetUserInfo(user_id).execute;
});
